export default ({ request }) => ({

  prjInputTemplateListApi (data = {}) {
    return request({
      url: '/digitalCenter/project/inputTemplate/list',
      method: 'post',
      data
    })
  },
  prjInputTemplateDetailApi (data = {}) {
    return request({
      url: '/digitalCenter/project/inputTemplate/detail',
      method: 'post',
      data
    })
  },
  prjInputTemplateSaveApi (data = {}) {
    return request({
      url: '/digitalCenter/project/inputTemplate/save',
      method: 'post',
      data
    })
  },
  prjInputTemplateDelApi (data = {}) {
    return request({
      url: '/digitalCenter/project/inputTemplate/del',
      method: 'post',
      data
    })
  }
})